// extracted by mini-css-extract-plugin
export default {"container":"Services_container__Kwb7Y","cardGroups":"Services_cardGroups__UbS1m"};